import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=543309d6&scoped=true"
import script from "./customer-list.vue?vue&type=script&lang=js"
export * from "./customer-list.vue?vue&type=script&lang=js"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=543309d6&lang=scss"
import style1 from "./customer-list.vue?vue&type=style&index=1&id=543309d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543309d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543309d6')) {
      api.createRecord('543309d6', component.options)
    } else {
      api.reload('543309d6', component.options)
    }
    module.hot.accept("./customer-list.vue?vue&type=template&id=543309d6&scoped=true", function () {
      api.rerender('543309d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/admin/customer-list.vue"
export default component.exports